import React, { useEffect, useMemo, useState, useRef } from 'react';
import Script from 'next/script';

import { ISmartSiteContext } from '../../api/smartApi';
// import { isMobile } from '../../util/device';

import { Context } from './use-smart-site';
import { useScreenSize } from '../ScreenSize';

export { Context, useSmartSite } from './use-smart-site';

interface IProps extends ISmartSiteContext {
  children: React.ReactNode;
  onLoaded?: () => void;
}

const ENV = process.env.NEXT_ENV || 'staging';

function SmartSiteProvider(props: IProps) {
  const { children, __smart, onLoaded } = props;
  const [isPC, setIsPC] = useState(true);
  const { size } = useScreenSize();

  const onLoadRef = useRef(onLoaded);

  const contextVal = useMemo(() => {
    return {
      __smart,
    };
  }, [__smart]);

  useEffect(() => {
    if (size?.width <= 0) {
      return;
    }
    const isPc = size?.width >= 1024;
    setIsPC(isPc);
    if ((window as any).System) {
      onLoadRef.current?.();
    }
  }, [size]);

  return (
    <>
      <Script
        src="https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:72e1c59f/system.min.js"
        onLoad={() => {
          onLoaded?.();
        }}
      />
      <Script src="https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:72e1c59f/amd.min.js" />
      <Script
        id="systemjs-importmap"
        type="systemjs-importmap"
        dangerouslySetInnerHTML={{
          __html: `{
          "imports": {
            "date-fns": "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6fe402b6/date_fns.min.js",
            "swiper": "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6fe402b6/swiper.min.js",
            "lodash": "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6fe402b6/lodash.min.js",
            "axios": "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6fe402b6/axios.min.js",
            "vue-awesome-swiper": "https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:6fe402b6/vue-awesome-swiper.min.js"
          }
        }`,
        }}
      />
      {!isPC ? (
        <link
          rel="stylesheet"
          href={
            ENV === 'production'
              ? 'https://s3plus.sankuai.com/v1/mss_5d36254f5d7d4de5ad564fb3bb84682c/hfe-assets/capfe/smart/smart-mo-components/smart.style.min.css'
              : 'https://s3plus.sankuai.com/v1/mss_5d36254f5d7d4de5ad564fb3bb84682c/hfe-assets-st/capfe/smart/smart-mo-components/smart.style.min.css'
          }
        />
      ) : (
        <link
          rel="stylesheet"
          href={
            ENV === 'production'
              ? 'https://s3plus.sankuai.com/v1/mss_5d36254f5d7d4de5ad564fb3bb84682c/hfe-assets/capfe/smart/smart-components/smart.style.min.css'
              : 'https://s3plus.sankuai.com/v1/mss_5d36254f5d7d4de5ad564fb3bb84682c/hfe-assets-st/capfe/smart/smart-components/smart.style.min.css'
          }
        />
      )}
      <Context.Provider value={contextVal}>{children}</Context.Provider>
    </>
  );
}

export { SmartSiteProvider };
